export default __webpack_public_path__ + "static/media/TTP_Broken Promises_Appendix B.74627a5d.pdf";